<template>
<!-- 新增子菜单 -->
  <el-dialog
    :title="$t('button.addSubmenu')"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="auto"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('pages.system.text118')" prop="menuName">
          <el-input v-model="ruleForm.menuName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text119')" prop="url">
          <el-input v-model="ruleForm.url"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text120')">
          <el-switch v-model="ruleForm.hidden"> </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('button.determine')}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
export default {
  data() {
    return {
      ruleForm: {
        isLeaf: 1, //是否是子节点
        level: 1, //所在层级
        menuName: "", //菜单名称
        menuPid: "", //菜单的父节点
        status: 0, //状态，是否启用
        url: "", //权限路由path
        hidden: false,
      },
      rules: {
        menuName: [
          { required: true, message: this.$t('pages.system.text121'), trigger: "blur" },
        ],
        url: [
          { required: true, message: this.$t('pages.system.text122'), trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    dialogVisible() {
      this.ruleForm.menuPid = null;
      this.ruleForm.level = null;
      this.ruleForm.menuName = null;
      this.ruleForm.url = null;
      this.ruleForm.id = null;
      //新增
      if (this.isAdd) {
        this.ruleForm.menuPid = this.currentMenu.id;
        this.ruleForm.level = this.currentMenu.level + 1;
      } else {
        //修改
        this.ruleForm.menuPid = this.currentMenu.menuPid;
        this.ruleForm.level = this.currentMenu.level;
        this.ruleForm.menuName = this.currentMenu.menuName;
        this.ruleForm.url = this.currentMenu.url;
        this.ruleForm.id = this.currentMenu.id;
        this.ruleForm.hidden = this.currentMenu.hidden;
      }
    },
  },
  props: ["dialogVisible", "currentMenu", "isAdd"],
  methods: {
    //取消
    handleClose() {
      this.ruleForm.menuPid = null;
      this.ruleForm.level = null;
      this.ruleForm.menuName = null;
      this.ruleForm.url = null;
      this.ruleForm.hidden = false;
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.request
              .menuManagementAdd(this.ruleForm)
              .then(() => {
                this.$message.success(this.$t('public.text8'));
                this.$emit("dialogClose");
                this.$emit("listWithButtons");
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          } else {
            this.request
              .menuManagementEdit(this.ruleForm)
              .then(() => {
                this.$message.success(this.$t('public.text9'));
                this.$emit("dialogClose");
                this.$emit("listWithButtons");
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
</style>
